import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Zap, Clock } from 'lucide-react';
const TIMER_DURATION = 5 * 60; // 5 minutes
export function StickyAlertBar() {
  const [timeLeft, setTimeLeft] = useState(TIMER_DURATION);
  const isUrgent = timeLeft <= 60;
  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 0) return 0;
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const minutes = Math.floor(timeLeft / 60).toString().padStart(2, '0');
  const seconds = (timeLeft % 60).toString().padStart(2, '0');
  return <div className="fixed top-0 left-0 right-0 z-[60] bg-crimson text-white" data-id="element-183">
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.5
    }} className="max-w-7xl mx-auto px-3 py-2 flex items-center justify-center gap-2 sm:gap-3 text-center flex-wrap" data-id="element-184">
        <Zap size={14} className="flex-shrink-0 animate-pulse hidden sm:block" data-id="element-185" />

        <p className="text-[11px] sm:text-sm font-bold tracking-wide uppercase" data-id="element-186">
          ⚡ OFERTA LIMITADA: Solo quedan{' '}
          <span className="underline decoration-2" data-id="element-187">37 copias</span>
        </p>

        {/* Countdown timer pill */}
        <div className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full font-black text-sm sm:text-base tabular-nums tracking-tight transition-colors duration-500 ${isUrgent ? 'bg-white text-crimson-dark animate-pulse' : 'bg-crimson-dark/60 text-white border border-white/20'}`} data-id="element-188">
          <Clock size={13} className="flex-shrink-0" data-id="element-189" />
          <span data-id="element-190">
            {minutes}:{seconds}
          </span>
        </div>

        <Zap size={14} className="flex-shrink-0 animate-pulse hidden sm:block" data-id="element-191" />
      </motion.div>
    </div>;
}